module.exports = __webpack_public_path__ + "static/media/医院综合热能解决方案2.2c4d7454.jpg";